<template>
  <a-table
    class="table datatable thead-light dq-report-table"
    :columns="columns"
    :data-source="dataSource"
    :loading="loading"
    :pagination="pagination"
    @change="onChange"
    row-key="key"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'Month'">
        {{ record.period_label || record.period }}
      </template>

      <template v-else-if="moneyColumns.includes(column.key)">
        {{ currency }}
        {{
          Number(record[column.dataIndex] || 0).toLocaleString(undefined, {
            minimumFractionDigits: 2,
          })
        }}
      </template>
    </template>
  </a-table>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  currency: { type: String, default: "KES" },
  total: { type: Number, default: 0 },
  pageSize: { type: Number, default: 25 },
  current: { type: Number, default: 1 },
});
const emit = defineEmits(["change"]);

const columns = [
  { title: "Month", dataIndex: "period_label", key: "Month" },
  { title: "Loan Collections", dataIndex: "loan_repayments", key: "LoanCollections" },
  { title: "Savings Collections", dataIndex: "savings_deposits", key: "SavingsCollections" },
  { title: "Total Collected", dataIndex: "total_collections", key: "TotalCollected" },
];

const dataSource = computed(() =>
  (props.rows || []).map((r, idx) => ({
    key: r.period || idx,
    period: r.period,
    period_label: r.period_label,
    loan_repayments: r.loan_repayments,
    savings_deposits: r.savings_deposits,
    total_collections: r.total_collections,
  }))
);


const moneyColumns = ["LoanCollections", "SavingsCollections", "TotalCollected"];


const pagination = computed(() => ({
  total: props.total,
  pageSize: props.pageSize,
  current: props.current,
  showTotal: (t) => `Total ${t} items`,
}));

function onChange(pagination, filters, sorter) {
  emit("change", pagination, filters, sorter);
}
</script>

<style scoped>
@media (max-width: 767.98px) {
  :deep(.dq-report-table .ant-table) {
    min-width: 760px;
  }

  :deep(.dq-report-table .ant-table-cell) {
    vertical-align: top;
    white-space: normal;
  }
}
</style>
